import { Outlet, Route, Routes } from "react-router-dom";
import Home from "./components/index/Home";
import { useEffect, useState } from "react";
import ProductDetails from "./components/productDetails/ProductDetails";
import { Footer, Header } from "./components/index";
import Login from "./components/Accounts/Login";
import { getFullNameFromCookie, isTokenValid } from "./utility/Cookies";
import AboutUs from "./components/About_Contact/AboutUs";
import ContactUs from "./components/About_Contact/ContactUs";
import Faq from "./components/About_Contact/Faq";
import ShoppingCart from "./components/shopping/ShoppingCart";
import Profile from "./components/profile/Profile";
import BaseProfileScreen from "./components/profile/BaseProfileScreen";
import SectionUser from "./components/profile/SectionUser";
import ViewOrders from "./components/profile/ViewOrders";
import OrdersDetails from "./components/profile/OrdersDetails";
import ChangePassword from "./components/Accounts/ChangePassword";
import Register from "./components/Accounts/Register";
import SearchProduct from "./components/filterProduct/SearchProduct";
import { LoadMainScreenService } from "./services/MainScreen";
import Payment from "./components/responsePayment/Payment";
import { BASE_URL } from "./utility/BaseUrl";

function App() {
  const initialData = {
    category_h_list: [],
    categories: [],
    product_h_list: [],
    sliders: [],
    setting: [],
    banners: [],
    comments: [],
    products: [],
    slider_by_product: [],
    socials: [],
    about_us: [],
    site_rules: [],
    user: {
      id: 0,
      user_phone: "",
      name: "",
      family: "",
      image: "",
      register_date: "",
      addresses: [],
      cart: {
        id: 0,
        items: [],
        is_finished: false,
        total: "",
      },
    },
  };

  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    //   window.scrollTo(0, 0);
    async function LoadData() {
      let apiData = await LoadMainScreenService();
      if (apiData.setting[0].site_logo) {
        const link = document.querySelector("link");
        link.rel = "icon";
        link.href = BASE_URL + apiData.setting[0].site_logo;
        document.title = apiData.setting[0].site_main_title;
      }

      setData({
        ...data,
        category_h_list: apiData.category_h_list || [],
        categories: apiData.categories || [],
        product_h_list: apiData.product_h_list || [],
        sliders: apiData.sliders || [],
        setting: apiData.setting || [],
        banners: apiData.banners || [],
        comments: apiData.comments || [],
        slider_by_product: apiData.slider_by_product || [],
        products: apiData.products || [],
        socials: apiData.socials || [],
        about_us: apiData.about_us || [],
        site_rules: apiData.site_rules || [],
        user: apiData.user.id
          ? {
              id: apiData.user.id,
              user_phone: apiData.user.user_phone,
              name: apiData.user.name,
              family: apiData.user.family,
              image: apiData.user.image,
              register_date: apiData.user.register_date,
              addresses: apiData.user.addresses,
              cart: {
                id: apiData.user.cart.id,
                items: apiData.user.cart.items,
                is_finished: apiData.user.cart.is_finished,
                total: apiData.user.cart.total,
              },
            }
          : {},
      });
    }
    if (isTokenValid() && !data.user.id) LoadData();
    if (
      data.products.length == 0 &&
      data.product_h_list.length == 0 &&
      data.sliders.length == 0
    )
      LoadData();

    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }, []);

  return (
    <>
      {loading ? (
        <div className="content-wrapper no-sidebar">
          <span className="loading">
            <loading text="در حال بارگذاری...">
              <i className="fa fa-refresh fa-spin fa-fw " /> در حال بارگذاری...
            </loading>
          </span>
        </div>
      ) : null}
      <Header
        setData={setData}
        fullName={data.user.id ? data.user.name + " " + data.user.family : ""}
        category={data.categories}
        about={data.about_us}
        cart={data.user.cart ?? {}}
        setting={data.setting}
      />
      <Routes>
        <Route path="/" element={<Home setData={setData} data={data} />} />
        <Route
          path="/Product/:slug"
          element={<ProductDetails data={data} setData={setData} />}
        />
        <Route path="/About-Us" element={<AboutUs about={data.about_us} />} />
        <Route path="/Contact-Us" element={<ContactUs />} />
        <Route path="/Faq" element={<Faq faq={data.site_rules} />} />
        <Route
          path="/Shopping-Cart"
          element={<ShoppingCart user={data.user} setData={setData} />}
        />
        <Route path="/Search" element={<SearchProduct data={data} />} />
        <Route path="/Payment" element={<Payment user={data.user} />} />
        <Route path="/Account" element={<Outlet />}>
          <Route path="Login" element={<Login />} />
          <Route path="Register" element={<Register />} />
          <Route path="ChangePassword" element={<ChangePassword />} />

          <Route element={<BaseProfileScreen user={data.user} />}>
            <Route path="SectionUser" element={<SectionUser />} />
            <Route
              path="Profile"
              element={<Profile user={data.user} setData={setData} />}
            />
            <Route path="Orders" element={<ViewOrders />} />
            <Route path="Orders/:tracking_code" element={<OrdersDetails />} />
          </Route>
        </Route>
      </Routes>
      <Footer data={data} />
    </>
  );
}

export default App;
